module.exports = __webpack_public_path__ + "static/media/Finnovex-Asia-2025.3ac3465b.png";